import React from "react";
import "./promo.scss";
import { IProps } from "./promointerface";
import { useTranslation } from "react-i18next";
import { RESOURCE } from "../../../../const/resource";
import helperfunctions from "../../../../utils/helperfunctions";
import Loader from "../../../Loader";
import { Error } from "@progress/kendo-react-labels";

const Promo = (props: IProps) => {

    const { t } = useTranslation();

    return (
        <div className="promoCodeContent">
            {(props?.applyPromoRes?.loading || props?.deletePromoRes?.loading) && <Loader />}
            <div className="promoCode">
                <input
                    className="promoCodeValue"
                    placeholder=""
                    value={props?.inputValue}
                    onChange={(e) => props?.handleInputChange(e)}
                    onKeyDown={(e) => props.handleKeyDown(e)}
                    disabled={props?.applyPromoRes?.loading || !props?.itemSummaryDetails?.data?.total || props?.deletePromoRes?.loading}
                />
                <div className="promoApplyBtn ml-2">
                    <button
                        className={(props?.apply && !props?.deletePromoRes?.loading && props?.itemSummaryDetails?.data?.total) ? "ApplyBtn" : "ApplyBtnred"}
                        title={t(RESOURCE.MyK_Label_ShoppingCart_Promo_Apply)}
                        onClick={() => props?.handleclick()}
                    >
                        {t(RESOURCE.MyK_Label_ShoppingCart_Promo_Apply)}
                    </button>
                </div>
            </div>
            {props?.isError && <Error> {String(t(RESOURCE.MyK_Label_Enter_PromoCode))}</Error>}
            <div className="promoListContainer">

                {props?.itemSummaryDetails?.data?.promoDetailList?.length ? props?.itemSummaryDetails?.data?.promoDetailList?.map((promo: any, index: any) => (

                    <tr className="itemsummaryview">
                        {index == 0 ? <td className="summaryName">{t(RESOURCE.MyK_Label_ShoppingCart_Promo_Applied)}</td> : <td className="summaryName">{ }</td>}
                        <td className="summaryName">{promo?.promoCode}</td>
                        <td className="summaryRateView">
                            <div
                                style={{ color: 'green' }}
                                className="float-right summaryRate"
                            >
                                <span className="summaryRate">-$</span>
                                {helperfunctions.formatAmount(promo?.discountPrice)}
                            </div>
                        </td>
                        <td className="ActionMenuView">
                            <div className="float-right ActionMenu"
                                onClick={() => props?.onRemovePromoCode(promo)}
                                onKeyDown={() => { }}
                                title={t(RESOURCE.MyK_Label_ShoppingCart_Promo_Remove)}>
                                {t(RESOURCE.MyK_Label_ShoppingCart_Promo_Remove)}
                            </div>
                        </td>
                    </tr>
                )) : null}
            </div>
        </div>
    );
};

export default Promo;
